import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 text-center text-warm-mid text-sm border-t border-warm-dark/10" data-id="element-33">
        <p className="mb-3" data-id="element-34">
          © {new Date().getFullYear()} Mente de Campeón Inquebrantable. Todos
          los derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-6" data-id="element-35">
          <button onClick={() => setActiveModal('privacy')} className="underline underline-offset-2 hover:text-warm-dark transition-colors" data-id="element-36">
            Política de Privacidad
          </button>
          <span className="text-warm-dark/20" data-id="element-37">|</span>
          <button onClick={() => setActiveModal('terms')} className="underline underline-offset-2 hover:text-warm-dark transition-colors" data-id="element-38">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-warm-dark/50 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-39">
          <div className="bg-warm-bg border border-warm-dark/15 rounded-sm w-full max-w-2xl max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-40">
            <div className="sticky top-0 bg-warm-bg border-b border-warm-dark/10 px-8 py-5 flex items-center justify-between" data-id="element-41">
              <h2 className="text-2xl font-heading font-bold text-warm-dark" data-id="element-42">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-warm-mid hover:text-warm-dark transition-colors p-1" aria-label="Cerrar" data-id="element-43">
                <XIcon className="w-5 h-5" data-id="element-44" />
              </button>
            </div>

            <div className="px-8 py-8 text-warm-mid leading-relaxed space-y-6 text-sm" data-id="element-45">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-46" /> : <TermsContent data-id="element-47" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-warm-dark font-medium" data-id="element-48">
        Última actualización: Marzo 2026
      </p>

      <p data-id="element-49">
        En Mente de Campeón Inquebrantable, respetamos tu privacidad y nos
        comprometemos a proteger la información personal que compartas con
        nosotros. Esta política describe cómo recopilamos, usamos y protegemos
        tus datos.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-50">
        Información que Recopilamos
      </h3>
      <p data-id="element-51">
        Al realizar una compra, recopilamos únicamente la información necesaria
        para procesar tu pedido, incluyendo tu nombre, dirección de correo
        electrónico y datos de pago. No almacenamos información de tarjetas de
        crédito en nuestros servidores.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-52">
        Uso de la Información
      </h3>
      <p data-id="element-53">
        Utilizamos tu información exclusivamente para: procesar y entregar tu
        compra, enviarte el producto digital adquirido, y comunicarnos contigo
        en caso de ser necesario respecto a tu pedido.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-54">
        Protección de Datos
      </h3>
      <p data-id="element-55">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-56">
        Terceros
      </h3>
      <p data-id="element-57">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. Esto no incluye terceros de confianza que nos asisten en la
        operación de nuestro sitio web o en la conducción de nuestro negocio,
        siempre que dichas partes acuerden mantener esta información
        confidencial.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-58">
        Tus Derechos
      </h3>
      <p data-id="element-59">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, puedes comunicarte
        con nosotros a través de los canales disponibles en nuestra plataforma.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-warm-dark font-medium" data-id="element-60">
        Última actualización: Marzo 2026
      </p>

      <p data-id="element-61">
        Al adquirir el producto "Mente de Campeón Inquebrantable", aceptas los
        siguientes términos y condiciones. Te recomendamos leerlos detenidamente
        antes de realizar tu compra.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-62">
        Producto Digital
      </h3>
      <p data-id="element-63">
        Este es un producto digital en formato PDF. Una vez completada la
        compra, recibirás acceso inmediato al material. Debido a la naturaleza
        digital del producto, no se aceptan devoluciones una vez descargado el
        contenido.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-64">
        Uso Personal
      </h3>
      <p data-id="element-65">
        El contenido adquirido es para uso personal y familiar únicamente. Queda
        prohibida la reproducción, distribución, modificación o reventa del
        material sin autorización expresa por escrito.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-66">
        Descargo de Responsabilidad
      </h3>
      <p data-id="element-67">
        El contenido de esta guía tiene fines educativos e informativos. No
        sustituye el consejo profesional de un psicólogo, terapeuta o
        profesional de la salud mental. Los resultados pueden variar según cada
        individuo y su compromiso con la práctica de las técnicas.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-68">
        Propiedad Intelectual
      </h3>
      <p data-id="element-69">
        Todo el contenido, incluyendo textos, gráficos, metodologías y
        materiales complementarios, está protegido por derechos de autor.
        Cualquier uso no autorizado constituye una violación de estos derechos.
      </p>

      <h3 className="font-heading font-bold text-warm-dark text-lg uppercase" data-id="element-70">
        Modificaciones
      </h3>
      <p data-id="element-71">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación. El uso continuado del producto después de dichos cambios
        constituye la aceptación de los nuevos términos.
      </p>
    </>;
}